'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var components_flexBox_FlexBox = require('../flexBox/FlexBox.js');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
var theme_index = require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/InternalFlexBox-BDDWEQ9L.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

require("../../_assets/Background-BIA5nrlW.css");var styles = {"background":"Background__aFddaKY8F7__background"};

const Background = react.forwardRef(({ className, style, color = 'white', ...props }, ref) => {
    return (jsxRuntime.jsx(components_flexBox_FlexBox.FlexBox, { className: utilities_combineClasses.combineClasses(className, styles.background), style: {
            '--background--background-color': theme_index.theme.color[color],
            ...style,
        }, ...props, ref: ref }));
});
Background.displayName = 'Background';

exports.Background = Background;
//# sourceMappingURL=Background.js.map
